<template>

  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
    height="100%"
  >
    <b-card
      class="d-flex justify-content-center"
    >
      <b-row v-if="alertShow">
        <b-col sm="12">
          <b-alert
            variant="success"
            show
            class="px-1"
          >
            <div class="alert-body p-2">
              <h4>
                {{ $t('successful-deposit-registration') }}
              </h4>
            </div>
          </b-alert>

        </b-col>
      </b-row>
      <div class="pricing-free-trial">
        <b-row>
          <b-col
            lg="12"
            offset-lg="3"
            class="mx-auto"
          >
            <div class="pricing-trial-content d-flex justify-content-between">
              <div class="text-md-left mt-3 w-100">
                <h3 class="text-primary">
                  {{ $t('wireDepositTitle') }}
                </h3>
                <h5> {{ $t('wireDepositDescription') }}</h5>
                <div
                  v-if="!ShowAedBankInfo"
                  class="mx-auto mx-md-0"
                  style="max-width: 600px;"
                >
                  <b-card class="bg-dark-blue text-white">
                    <b-row
                      class="d-flex"
                      dir="rtl"
                    >
                      <b-col
                        v-if="bankAccountInfo"
                        class="text-center text-lg-right w-75"
                      >
                        <span class="pa-2 d-block mb-1 d-block d-lg-none ">{{ $t('accountNumber') }}</span>
                        <span class="pa-2 d-block">{{ bankAccountInfo.card_number }}</span>
                        <br>
                        <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('iban') }}</span>
                        <span class="pa-2 d-block">{{ bankAccountInfo.iban }}</span>
                        <br>
                        <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('accountOwner') }}</span>
                        <span class="pa-2 d-block">{{ bankAccountInfo.card_name }}</span>
                        <br>
                        <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('bank') }}</span>
                        <span class="pa-2 d-block"> {{ bankAccountInfo.bank_name }}</span>
                      </b-col>
                      <b-col
                        cols="1"
                        class="text-center text-lg-right w-25  d-none d-lg-block"
                      >
                        <span class="pa-2  d-block">:</span>
                        <br>
                        <span class="pa-2 d-block">:</span>
                        <br>
                        <span class="pa-2 d-block">:</span>
                        <br>
                        <span class="pa-2 d-block">:</span>
                      </b-col>
                      <b-col
                        cols="3"
                        class="text-center text-lg-right w-25  d-none d-lg-block"
                      >
                        <span class="pa-2 text-nowrap d-block">{{ $t('accountNumber') }}</span>
                        <br>
                        <span class="pa-2 d-block">{{ $t('iban') }}</span>
                        <br>
                        <span class="pa-2 d-block">{{ $t('accountOwner') }}</span>
                        <br>
                        <span class="pa-2 d-block">{{ $t('bank') }}</span>
                      </b-col>

                    </b-row>
                  </b-card>
                </div>
                <div
                  v-if="ShowAedBankInfo"
                  class="mx-auto mx-md-0"
                  style="max-width: 700px;"
                >
                  <b-card class="bg-dark-blue text-white">
                    <b-row class="d-flex">

                      <b-col
                        v-if="bankAccountInfo"
                        class="text-center text-lg-right w-75"
                      >
                        <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('accountNumber') }}</span>
                        <span class="pa-2 d-block text-nowrap">0012-113274-001</span>
                        <br>
                        <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('iban') }}</span>
                        <span class="pa-2 d-block text-nowrap">AE200400000012113274001</span>
                        <br>
                        <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('accountOwner') }}</span>
                        <span class="pa-2 d-block text-nowrap">Master Line General Trading LLC</span>
                        <br>
                        <span class="pa-2 d-block mb-1 d-block d-lg-none">{{ $t('bank') }}</span>
                        <span class="pa-2  d-block ">National Bank of Ras-Al Kaimah <span class="text-nowrap">(RAK
                          Bank)</span></span>
                        <br>
                        <span class="pa-2 d-block mb-1 d-block d-lg-none">Swift Code</span>
                        <span class="pa-2 d-block text-nowrap">NRAKAEAK</span>
                      </b-col>
                      <b-col
                        cols="1"
                        class="w-25 text-center text-lg-right d-none d-lg-block"
                      >
                        <span class="pa-2  d-block">:</span>
                        <br>
                        <span class="pa-2 d-block">:</span>
                        <br>
                        <span class="pa-2 d-block">:</span>
                        <br>
                        <span class="pa-2 d-block">:</span>
                        <br>
                        <span class="pa-2 d-block">:</span>
                      </b-col>
                      <b-col
                        cols="3"
                        class="w-25 text-center text-lg-right d-none d-lg-block"
                      >
                        <span class="pa-2  d-block">{{ $t('accountNumber') }}</span>
                        <br>
                        <span class="pa-2 d-block">{{ $t('iban') }}</span>
                        <br>
                        <span class="pa-2 d-block">{{ $t('accountOwner') }}</span>
                        <br>
                        <span class="pa-2 d-block">{{ $t('bank') }}</span>
                        <br>
                        <span class="pa-2 d-block">Swift Code</span>
                      </b-col>
                    </b-row>
                  </b-card>
                </div>
              </div>
              <!-- images -->
              <b-img
                fluid
                :src="require('@/assets/images/illustration/pricing-Illustration.svg')"
                class="pricing-trial-img d-none d-md-block"
                alt="svg img"
              />
              <!--/ images -->
            </div>
          </b-col>
        </b-row>
      </div>
      <hr>
      <validation-observer ref="depositform">
        <b-form>
          <b-row>
            <b-col md="4">
              <b-form-group
                label-for="Currency"
                :label="$t('fiat_wallet_deposit_currency')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('fiat_wallet_deposit_currency')"
                  vid="Currency"
                  rules="required"
                  :required="!currency"
                >
                  <v-select
                    id="Currency"
                    v-model="currency"
                    :options="options"
                    :placeholder="$t('fiat_wallet_deposit_currency')"
                    label="name"
                    track-by="name"
                    @input="onCurrencyChange"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label-for="bankAccountSelect"
                :label="$t('bank')"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('bank')"
                  vid="Bank"
                  rules="required"
                >
                  <v-select
                    id="bankAccountSelect"
                    v-model="bankAccountInfo"
                    :options="bankAccounts"
                    :placeholder="$t('bank')"
                    label="bank_name"
                    track-by="account_number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              sm="12"
              xl="4"
            >
              <b-form-group
                :label="$t('fiat_wallet_deposit_amount')"
                label-for="hear-description"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('fiat_wallet_deposit_amount')"
                  rules="required|numeric"
                >

                  <b-form-input
                    v-model="amount"
                    name="hear-description"
                    :placeholder="$t('fiat_wallet_deposit_amount')"
                    autocomplete="nope"
                    @keypress="onlyNumbers($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>

                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-col class="p-0">
            <b-form-group
              label-size="lg"
              :label="$t('deposit_Receipt')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('deposit_Receipt')"
                :rules="'required|size:'+MAX_IMAGE_UPLOAD_SIZE"
              >
                <b-form-file
                  id="file-large"
                  v-model="file"
                  size="lg"
                  accept="image/png, image/jpg, image/jpeg"
                  :placeholder="$t('fiat_wallet_deposit_receipt_file')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-form>
      </validation-observer>
      <b-col cols="12">
        <b-button
          v-if="!pending"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mt-2 mr-1"
          :disabled="!bankAccountInfo"
          @click="submit"
        >
          {{ $t('fiat_wallet_deposit_send_button') }}
        </b-button>
        <b-button
          v-if="pending"
          variant="primary"
          class="mt-1 mr-1"
          disabled
        >
          <b-spinner
            small
            type="grow"
          />
          {{ $t('fiat_wallet_deposit_loading') }}
        </b-button>
      </b-col>
    </b-card>
    <!-- 4. Deposit History -->
    <b-card class="deposit-history">
      <h3 class="mb-0">
        {{ $t('deposit_history') }}
      </h3>
      <br>
      <b-table
        :items="depositHistory"
        :fields="historyFields"
        small
        bordered
        responsive
      >
        <template #cell(amount)="data">
          <span>{{ helpers.numberWithCommas(helpers.toFixed(data.item.amount, 2)) }}</span>
        </template>
        <template #cell(automation.status)="data">
          <b-button
            size="sm"
            :variant=" data.item.automation.status === 'pending' ? 'warning' : data.item.automation.status === 'successful' ? 'success' :data.item.automation.status === 'rejected'? 'outline-info': 'danger'"
          >
            {{ data.item.automation.status }}
          </b-button>
        </template>
      </b-table>
    </b-card>
  </b-overlay>

</template>
<script>
import FiatDeposit from '@/modules/crypto/views/logic/customer-wallets/fiat/FiatDeposit'

export default {
  mixins: [FiatDeposit],
}
</script>
<style scoped>
.bg-dark-blue {
  background-color: rgb(2, 58, 110);
}
</style>
